// 技术1菜单
const menus = [
  {
    icon: 'el-icon-lx-home',
    index: '/simpleIndex',
    title: '系统首页',
  },
  {
    icon: 'el-icon-lx-cascades',
    index: '11',
    title: '系统管理',
    subs: [
      {
        index: '/banner',
        title: 'banner',
      },
      {
        index: '/navigation',
        title: '导航栏',
      },
      {
        index: '/brochureList',
        title: '宣传页',
      },
    ],
  },
  
]

export default menus
